import { SET_ERROR_MESSAGE, VIEW_ERROR_MESSAGE } from 'helpers/types';

const INITIAL_STATE = {
  errorMessage: '',
  newMessage: true,
  link: '',
  ctaText: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_ERROR_MESSAGE:
      return {
        errorMessage: action.payload.msg || '',
        link: action.payload.link || '',
        ctaText: action.payload.ctaText || '',
        newMessage: true,
      };
    case VIEW_ERROR_MESSAGE:
      if (state.newMessage)
        return {
          ...state,
          errorMessage: state.errorMessage,
          newMessage: false,
        };
      else
        return {
          ...state,
          errorMessage: '',
          newMessage: false,
        };
    default:
      return state;
  }
};
